import store from '../../../store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import CordovaController from '@/assets/ts/controller/CordovaController';
import OfflineController from '@/assets/ts/controller/OfflineController';

interface OcorrenciaAprovacao {
  NRPROGOCORRENCIA:         string,
  NRVINCULOM:               string,
  NMVINCULOM:               string,
  NRTIPOPROGOCORRENCIA:     string,
  NRMOTIVOOCORFREQ:         string,
  DTINICIOPROGOCOR:         string,
  DTFIMPROGOCOR?:           string,
  DSOBSERVACAO?:            string,
  IDDIASSEMANA:             string;
  IDTIPODIACALENDARIO?:     string,
  IDTIPOHORARIO?:           string,
  NRHORDIAM?:               string,
  NRSITUFREQUENCIA?:        string,
  IDAPROVACAO?:             'A' | 'R';
  EXTRA_ROW?: {
    CDSTATUS?: string,
  },
}

class OcorrenciaController {
  public static downloadOcorrenciaFile(
    nrVinculo: string,
    nrMarcacao: number,
    date: string,
  ): Promise<void> {
    return new Promise(async (resolve, reject) => {

      const nrOrg = this.getNrOrg();
      const route = 'getOcorrenciaFile';

      const params = {
        requestType: 'FilterData',
        NRORG: nrOrg,
        NRPROGOCORRENCIA: nrMarcacao,
      };

      if(OfflineController.isMobile()) {
        try {
          await CordovaController.checkStorageAccessMobile();
        } catch (error) {
          const message = 'Permissões de armazenamento são necessárias para baixar o relatório. Por favor, revise as permissões e tente novamente.';
          SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
          return;
        }
      }

      try {
        const response = await HttpRequest.get(route, params, false);

        if (typeof response.data === 'string') {
          throw new Error(response.data);
        }

        if (response.data.messages) {
          throw new Error(response.data.messages[0].message);
        }

        const {base64, type} = response.data.dataset.data;

        if (!(base64 && type)) {
          throw new Error('Arquivo e tipo não informados');
        }

        const dateUnderscore = Util.replaceAll(date, '/', '_');
        const extension = FileUtils.mimeTypeToExtension(type);

        const fileName = `ocorrencia-${nrVinculo}-${dateUnderscore}.${extension}`;

        FileUtils.downloadBase64File(fileName, base64, type);

        const message = 'Arquivo baixado com sucesso!';
        SnackbarUtils.showMessage(message, 'success', 5000);

        resolve();
      } catch (err) {
        const message = 'Não foi possível baixar o arquivo.';
        SnackbarUtils.showMessage(message, 'error', 5000);

        throw err;
      }
    });
  }

  private static getNrOrg(): number {
    const nrOrg = store.getters.user.nrorg;
    const nrOrgInt = parseInt(nrOrg, 10);

    return nrOrgInt;
  }

  public static async getOcorrenciaFile(
    nrOcorrencia: string,
  ) {
    const nrOrg = this.getNrOrg();
    const route = 'getOcorrenciaFile';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRPROGOCORRENCIA: nrOcorrencia,
    };

    try {
      const response = await HttpRequest.get(route, params, false);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      if (response.data.messages) {
        throw new Error(response.data.messages[0].message);
      }

      const fileData: {base64: string, type: string} = response.data.dataset.data;

      return fileData;
    } catch (err) {
      const message = 'Não foi possível carregar o arquivo.';
      SnackbarUtils.showMessage(message, 'error');

      throw err;
    }
  }

  public static async removeOcorrenciasFreq(
    nrVinculo: string,
    dates: string[],
    hrMarcacao: string,
    showLoading = true,
  ) {
    const route = 'removeOcorrenciasFreq';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        DATE: dates,
        HORAMARCACAO: hrMarcacao,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const success: boolean = response.data.dataset.data.success;

    return success;
  }

  public static async removeAlmocos(
    nrVinculo: string,
    dates: string[],
    showLoading = true,
  ) {
    const route = 'removeAlmocos';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        DATE: dates,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const success: boolean = response.data.dataset.data.success;

    return success;
  }

  public static async getEventosAtivos(
    showLoading = true,
  ) {
    const route = 'getEventosAtivos';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const eventos: any[] = response.data.dataset.data;

      return eventos;
    } catch (err) {
      const message = 'Não foi possível carregar os eventos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
 
  public static async aprovaOcorrencia(
    nrprogocorrencia: string
  ) {
    try {
      const response = await HttpRequest.post('aprovarOcorrencia', {
        requestType: 'Row',
        row: {
          NRPROGOCORRENCIA: nrprogocorrencia,
          NRORG: store.getters.user.nrorg,
          CDOPERADOR: store.getters.user.cdoperador,
        },
      });

      if (response.data.messages) {
        throw response.data.messages[0].message;
      }

      return true;
    } catch (err) {
      SnackbarUtils.showMessage((err as string), SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async rejeitaOcorrencia(
    nrprogocorrencia: string,
    dsObservacao: string = null
  ) {
    try {
      const response = await HttpRequest.post('rejeitarOcorrencia', {
        requestType: 'Row',
        row: {
          NRPROGOCORRENCIA: nrprogocorrencia,
          DSOBSERVACAO: dsObservacao,
          NRORG: store.getters.user.nrorg,
          CDOPERADOR: store.getters.user.cdoperador,
        },
      });

      if (response.data.messages) {
        throw response.data.messages[0].message;
      }

      return true;
    } catch (err) {
      SnackbarUtils.showMessage((err as string), SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
}

export { OcorrenciaController, OcorrenciaAprovacao };